import React from 'react';
import PropTypes from 'prop-types';
import styles from './Charts.module.scss';

/* ────────────────────────────────────────────────────────────
 * ChartTooltip — themed Recharts tooltip content.
 *
 * Use as the `content` prop on Recharts <Tooltip>. Pulls the
 * tooltip bg/fg tokens via the host class so a theme flip
 * reflows it instantly.
 * ──────────────────────────────────────────────────────────── */

const ChartTooltip = ({ active, payload, label, valueFormatter, labelFormatter }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className={styles.tooltip} role="presentation">
      {label !== undefined && (
        <div className={styles.tooltipLabel}>
          {labelFormatter ? labelFormatter(label) : label}
        </div>
      )}
      <ul className={styles.tooltipList}>
        {payload.map((entry, i) => (
          <li key={`${entry.dataKey}-${i}`} className={styles.tooltipRow}>
            <span
              className={styles.tooltipSwatch}
              style={{ backgroundColor: entry.color }}
              aria-hidden="true"
            />
            <span className={styles.tooltipName}>{entry.name}</span>
            <span className={styles.tooltipValue}>
              {valueFormatter ? valueFormatter(entry.value, entry) : entry.value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

ChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueFormatter: PropTypes.func,
  labelFormatter: PropTypes.func,
};

ChartTooltip.defaultProps = {
  active: false,
  payload: [],
  label: undefined,
  valueFormatter: null,
  labelFormatter: null,
};

export default ChartTooltip;
